import { render, staticRenderFns } from "./RenderDatePicker.vue?vue&type=template&id=163bf67c&scoped=true&"
import script from "./RenderDatePicker.vue?vue&type=script&lang=js&"
export * from "./RenderDatePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163bf67c",
  null
  
)

export default component.exports